(function() {
    'use strict';

    var DisplayTemplateListCtrl = function($scope, ajaxCall, xmsNotificationFactory, $window) {
        $scope.dataCollectionModel = {};
        $scope.dataCollectionModel.errorMessageVal = 'Error';
        $scope.dataCollectionModel.errorMessage = false;
        $scope.dataCollectionModel.disableBtn = false;
        $scope.ajaxCallMethod = function(ajaxUrl, data, closePop) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                $scope.dataCollectionModel.disableBtn = false;
                if(result.data.success == true){
                    if(result.data.forwardUrl){
                        $window.location.href = result.data.forwardUrl;
                    } else {
                        $scope.dataCollectionModel.showSuccessMsg = true;
                        $scope.closePop();
                        xmsNotificationFactory.addObj({id: "DisplayTemplateListPop",
                            type: "success",
                            bodyHtml: result.data.message,
                            timeout:10});
                    }
                }
            }, function(result) {
                $scope.dataCollectionModel.disableBtn = false;
                $scope.dataCollectionModel.errorMessage = true;
                $scope.dataCollectionModel.errorMessageVal = errorMsg;
            });
        }

        $scope.dataCollSend = function($event) {
            $event.preventDefault();
            var isValid = this.dataForm.$valid;
            if (isValid) {
                $scope.dataCollectionModel.disableBtn = true;
                var data = $scope.dataCollectionModel;
                var ajaxUrl;
                if (data.screeningCaseId) {
                    ajaxUrl = WEBAPP_PATH + "/screeningCase/sendDisplayTemplateDCF";
                } else {
                    ajaxUrl = WEBAPP_PATH + "/dataCollection/sendCandidateDatacollectionForm";
                }
                $scope.ajaxCallMethod(ajaxUrl, data);
            }
        }


        $scope.closePop = function($event) {
            $scope.ok();
        }
        $scope.cancel = function() {
            $scope.ok();
        };
    }
    DisplayTemplateListCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory','$window'];
    angular.module('app').controller('DisplayTemplateListCtrl', DisplayTemplateListCtrl);


}());
